export var ResourceDisplayKind;
(function (ResourceDisplayKind) {
    ResourceDisplayKind["ACCOMMODATION"] = "ACCOMMODATION";
    ResourceDisplayKind["STAFF"] = "STAFF";
    ResourceDisplayKind["FACILITY"] = "FACILITY";
    ResourceDisplayKind["RESTAURANT"] = "RESTAURANT";
    ResourceDisplayKind["RESTAURANT_TABLE"] = "RESTAURANT_TABLE";
})(ResourceDisplayKind || (ResourceDisplayKind = {}));
